import * as types from 'Redux/types/albums';
import yup from 'yup';

import { isLoggedInStore } from 'Helpers/User';
import { requestOptions } from 'Helpers/Graphql';

import AlbumQuery from 'Gql/queries/market.album.query';

import albumBasicsFragment from 'Gql/fragments/album.basics';
import albumDetailsFragment from 'Gql/fragments/album.details';
import photoBasicsFragment from 'Gql/fragments/photo.basics';
import photoCaptionFragment from 'Gql/fragments/photo.caption';
import photoDetailsFragment from 'Gql/fragments/photo.details';
import photoResolutionsGalleryFragment from 'Gql/fragments/photo.resolutions.gallery';
import photoLoggedInDetailsFragment from 'Gql/fragments/photo.loggedInDetails';

export const fetch = (params = {}, req = null) => (dispatch) => {
    params = {
        ...params,
        id: params.id,
        page: params.page || 1,
        perPage: params.perPage || 40
    };

    return requestOptions({
        req: req,
        type: types.FETCH,
        onRetry: fetch,
        name: 'marketAlbum',
        params: params,
        requestParams: {
            id: params.id,
            page: params.page,
            perPage: params.perPage
        },
        validateSuccess: response => response.data.album && response.data.album,
        validationSchema: yup.object().shape({
            data: yup.object().shape({
                album: yup.object().nullable()
            }).required()
        }),
        query: AlbumQuery
            .replace('%name%', 'marketAlbum')
            .replace('%fields%', `
                ...albumBasics
                ...albumDetails
                photos: photos(
                    page: $page
                    perPage: $perPage
                ) {
                    edges {
                        node {
                            ...photoBasics
                            ...photoCaption
                            ...photoResolutionsGallery
                            ...photoDetails
                            ${isLoggedInStore(req) ? '...photoLoggedInDetails' : ''}
                        }
                    }
                    perPage
                    totalCount
                }
            `)
            .replace('%fragments%', `
                ${albumBasicsFragment}
                ${albumDetailsFragment}
                ${photoBasicsFragment}
                ${photoCaptionFragment}
                ${photoResolutionsGalleryFragment}
                ${photoDetailsFragment}
                ${isLoggedInStore(req) ? photoLoggedInDetailsFragment : ''}
            `)
    });
};

export const updatePhotos = params => dispatch => {
    return dispatch({ type: types.UPDATE_PHOTOS, payload: params });
};



// WEBPACK FOOTER //
// ./src/redux/actions/albums.js